// Import version.json at build time - webpack will bundle the JSON content
import versionJson from '../../version.json';

export interface VersionInfo {
  majorVersion: number;
  minorVersion: number;
  patchVersion: number;
  year: number;
}

/**
 * Loads version information from version.json
 * Please double-check with project lead before incrementing major version number. 
 * Major version changes only happen when the nature of the change is considered an OVERHAUL. 
 * Please refer to SEMVER documentation for more details.
 *
 * SEMVER: https://semver.org/
 */
export function loadVersionInfo(): VersionInfo {
  try {
    const releaseVersion: string = versionJson.version.release;

    const majorVersion = +releaseVersion.substring(0, releaseVersion.indexOf('.'));
    const minorVersion = +releaseVersion.substring(releaseVersion.indexOf('.') + 1);
    const patchVersion = versionJson.version.build ?? 0;
    const year = new Date().getFullYear();

    return {
      majorVersion,
      minorVersion,
      patchVersion,
      year
    };
  } catch (error) {
    console.error('Failed to load version info:', error);
    // Return default values if version.json is not available
    return {
      majorVersion: 0,
      minorVersion: 0,
      patchVersion: 0,
      year: new Date().getFullYear()
    };
  }
} 